/**
 * Цели Яндекс.Метрики (reachGoal). Без счётчика на странице — no-op.
 * Номера целей — из интерфейса Метрики (счётчик 109694146), для справки.
 * Идентификатор в reachGoal должен совпадать с полем «Идентификатор» цели (тип: JavaScript-событие).
 */
import { getYandexMetrikaId } from './yandexMetrika';

/** @type {Record<string, number>} */
export const METRIKA_GOAL_NUMBERS = {
  gen_ai_creative_deck_download: 566625392,
  gen_ai_creative_form_submit: 566625443,
  lead_contact_submit: 566625462,
  gen_ai_creative_cta_deck: 566625484,
  cta_contact_header: 566625565,
  cta_phone_click: 566625614,
  cta_email_click: 566625631,
  cta_calendly_click: 566625632,
  cta_expert_vendor: 566625665,
  cta_expert_catalog: 566625698,
  cta_questions_product: 566625748,
  cta_cbr_discuss_tariff: 566625767,
  cta_floating_home: 566625768,
  cta_free_consultation: 566625786,
};

export function reachMetrikaGoal(goalId) {
  if (!goalId || typeof window === 'undefined') return;
  if (typeof window.ym !== 'function') return;
  window.ym(getYandexMetrikaId(), 'reachGoal', goalId);
}

export function trackContactHeaderClick() {
  reachMetrikaGoal('cta_contact_header');
}

export function trackPhoneClick() {
  reachMetrikaGoal('cta_phone_click');
}

export function trackCalendlyClick() {
  reachMetrikaGoal('cta_calendly_click');
}

export function trackEmailClick() {
  reachMetrikaGoal('cta_email_click');
}

export function trackExpertVendorClick() {
  reachMetrikaGoal('cta_expert_vendor');
}

export function trackExpertCatalogClick() {
  reachMetrikaGoal('cta_expert_catalog');
}

export function trackQuestionsProductCalendlyClick() {
  reachMetrikaGoal('cta_questions_product');
}

export function trackCbrDiscussTariffClick() {
  reachMetrikaGoal('cta_cbr_discuss_tariff');
}

export function trackFloatingHomeClick() {
  reachMetrikaGoal('cta_floating_home');
}

export function trackFreeConsultationClick() {
  reachMetrikaGoal('cta_free_consultation');
}

export function trackLeadContactSubmit(calculatorData) {
  const goalId =
    calculatorData?.requestType === 'gen_ai_creative'
      ? 'gen_ai_creative_form_submit'
      : 'lead_contact_submit';
  reachMetrikaGoal(goalId);
}
